// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import locale from "element-ui/lib/locale/lang/zh-CN";
import { Message } from "element-ui";
import "@/styles/index.scss"; // global css

import VueQuillEditor from "vue-quill-editor"; //  引入vue富文本编辑器
import "quill/dist/quill.core.css"; //  引入vue富文本编辑器
import "quill/dist/quill.snow.css"; //  引入vue富文本编辑器
import "quill/dist/quill.bubble.css"; //  引入vue富文本编辑器
import baseUrl from "@/fetch/url_teach";

// let _frameType = getCookies("frameType") || "";
//   if (_frameType) {
//     if (_frameType === "study") {
//       _api = api_study.url;
//     } else if (_frameType === "teach") {
//       _api = api_teach.url;
//     }
//   }

console.log(2323232111)

// import "@/permission"; // permission control

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// set ElementUI lang to EN
Vue.use(ElementUI, { locale }).use(VueQuillEditor);
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)
Vue.prototype.$message = Message;
Vue.prototype.$imgUrl = baseUrl.imgUrl;
Vue.prototype.$pageUrl = baseUrl.pageUrl;
Vue.prototype.$studentPageBaseUrl = baseUrl.studentPageBaseUrl;

Vue.config.productionTip = false;

/* eslint-disable no-new */
export const vm = new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js